const { useState } = require("react");
const { useLocation } = require("react-router");

function useUrlSearchParams(targetParams) {
  const location = useLocation()
  const [params] = useState(() => {
    const searchParams = new URLSearchParams(location.search)
    if (targetParams) {
      return targetParams.reduce((result, targetParam) => {
        return result[targetParam] = searchParams.get(targetParam)
      }, {})
    } else {
      const params = {}
      for (const pair of searchParams.entries()) {
        params[pair[0]] = pair[1]
      }
      return params;
    }
  })
  return params
}

export default useUrlSearchParams